import { IEmployeeWorkgroupData } from '@/models';
import { IEmployeeWorkgroupService } from './employee-workgroup.types';
import { AxiosInstance } from 'axios';

export class EmployeeWorkgroupService implements IEmployeeWorkgroupService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/employees/workgroups/';
  }

  fetchEmployeeWorkgroups(): Promise<IEmployeeWorkgroupData[]> {
    return this.axios
      .get<IEmployeeWorkgroupData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchEmployeeWorkgroup(id: number): Promise<IEmployeeWorkgroupData> {
    return this.axios
      .get<IEmployeeWorkgroupData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createEmployeeWorkgroup(
    data: IEmployeeWorkgroupData
  ): Promise<IEmployeeWorkgroupData> {
    return this.axios
      .post<IEmployeeWorkgroupData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateEmployeeWorkgroup(
    data: IEmployeeWorkgroupData
  ): Promise<IEmployeeWorkgroupData> {
    return this.axios
      .patch<IEmployeeWorkgroupData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteEmployeeWorkgroup(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
